export var colorObj = {
    white: '#fff',
    black: '#2A3034',
    darkgray: '#2E2D2B',
    darkbrown: '#4B3132',
    red: '#C64839',
    brickred: '#E36650',
    pumporange: '#E7894B',
    dryyellow: '#F1DB63',
    lemonjuiceyellow: '#F2E4B3',
    peagreen: '#A4B54D',
    denimblue: '#96AAC1',
    oldblue: '#768488',
    fonts: {
        white: '#151514',
        black: '#FEFEFE',
        darkgray: '#FEFEFE',
        darkbrown: '#FEFEFE',
        red: '#FEFEFE',
        brickred: '#FEFEFE',
        pumporange: '#FEFEFE',
        dryyellow: '#151514',
        lemonjuiceyellow: '#151514',
        peagreen: '#151514',
        denimblue: '#151514',
        oldblue: '#151514'
    }
};
//# sourceMappingURL=colorObj.js.mapexport var colorObj = {
    white: '#fff',
    black: '#2A3034',
    darkgray: '#2E2D2B',
    darkbrown: '#4B3132',
    red: '#C64839',
    brickred: '#E36650',
    pumporange: '#E7894B',
    dryyellow: '#F1DB63',
    lemonjuiceyellow: '#F2E4B3',
    peagreen: '#A4B54D',
    denimblue: '#96AAC1',
    oldblue: '#768488',
    fonts: {
        white: '#151514',
        black: '#FEFEFE',
        darkgray: '#FEFEFE',
        darkbrown: '#FEFEFE',
        red: '#FEFEFE',
        brickred: '#FEFEFE',
        pumporange: '#FEFEFE',
        dryyellow: '#151514',
        lemonjuiceyellow: '#151514',
        peagreen: '#151514',
        denimblue: '#151514',
        oldblue: '#151514'
    }
};
//# sourceMappingURL=colorObj.js.map